import Vue from 'vue';
import VueRouter from 'vue-router';
import OverView from '@/views/overView/index.vue';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    // 总览
    path: '/',
    name: 'overView',
    component: OverView,
  },
  {
    // 充电统计
    path: '/chargingStats',
    name: 'chargingStats',
    component: () => import(/* webpackChunkName: "chargingStats" */ '../views/chargingStats/index.vue'),
  },
  {
    // 光伏统计
    path: '/pvStats',
    name: 'pvStats',
    component: () => import(/* webpackChunkName: "pvStats" */ '../views/pvStats/index.vue'),
  },
  {
    // 储能统计
    path: '/energyStorageStats',
    name: 'energyStorageStats',
    component: () => import(/* webpackChunkName: "energyStorageStats" */ '../views/energyStorageStats/index.vue'),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
